var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkNavigate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 2.50098C10.9477 2.50098 10.5 2.05326 10.5 1.50098C10.5 0.948692 10.9477 0.500977 11.5 0.500977H16.5C17.0523 0.500977 17.5 0.948692 17.5 1.50098V6.50098C17.5 7.05326 17.0523 7.50098 16.5 7.50098C15.9477 7.50098 15.5 7.05326 15.5 6.50098V3.91519L8.04044 11.3748C7.64992 11.7653 7.01675 11.7653 6.62623 11.3748C6.2357 10.9842 6.2357 10.3511 6.62623 9.96054L14.0858 2.50098H11.5ZM3.16667 5.00098C2.98986 5.00098 2.82029 5.07121 2.69526 5.19624C2.57024 5.32126 2.5 5.49083 2.5 5.66764V14.8343C2.5 15.0111 2.57024 15.1807 2.69526 15.3057C2.82029 15.4307 2.98986 15.501 3.16667 15.501H12.3333C12.5101 15.501 12.6797 15.4307 12.8047 15.3057C12.9298 15.1807 13 15.0111 13 14.8343V9.83431C13 9.28202 13.4477 8.83431 14 8.83431C14.5523 8.83431 15 9.28202 15 9.83431V14.8343C15 15.5416 14.719 16.2198 14.219 16.7199C13.7189 17.22 13.0406 17.501 12.3333 17.501H3.16667C2.45942 17.501 1.78115 17.22 1.28105 16.7199C0.780952 16.2198 0.5 15.5416 0.5 14.8343V5.66764C0.5 4.9604 0.780951 4.28212 1.28105 3.78203C1.78115 3.28193 2.45942 3.00098 3.16667 3.00098H8.16667C8.71895 3.00098 9.16667 3.44869 9.16667 4.00098C9.16667 4.55326 8.71895 5.00098 8.16667 5.00098H3.16667Z",
    fill: "#1776B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkNavigate);
export default __webpack_public_path__ + "static/media/link-navigate.546f1e4d8ae7cdb118a687c755314f83.svg";
export { ForwardRef as ReactComponent };